import { BlitsError } from "./blits.error";

export class UserNotAssignedToTenantError extends BlitsError {
    static readonly CODE = "user_not_assigned_to_tenant_error";

    constructor(message?: string) {
        super(UserNotAssignedToTenantError.CODE, message || 'Your user is not assigned to any tenant! Please, contact your tenant administrator.');
    }
}